export const AppDownloadNudge = [
    // Container with background and padding
    { span: 15, height: "296px", classes: "borderRadius-16 flex" }, // Main container
]

export const AppDownloadNudgeConfig = [
    // Simple single div with height from SCSS (296px default + 56px padding on each side = 408px total)
    { span: 24, height: "408px" },
]
